import { Button, ButtonProps } from '@fable/components'
import { css } from '@fable/theme'
import { Book } from '@fable/types'
import { useBuyBook } from 'hooks'

interface Props extends ButtonProps {
  book: Book
}

export const BookDetailBuyButton = ({ book, ...props }: Props) => {
  const { onSelectBook, loading, button } = useBuyBook({
    book: book as Book,
    isTestActive: true,
  })

  if (book?.is_out_of_catalog || !book?.can_purchase) return null

  return (
    <Button
      className={css`
        width: 100%;
      `}
      onClick={() => onSelectBook()}
      loading={loading}
      disabled={button.props.disabled}
      {...props}
    >
      {button.content}
    </Button>
  )
}
